import React from "react";
import PropTypes from "prop-types";
import { Grid } from "@mui/material";
import { USER_TYPES_WITH_ADMIN } from "../../../shared/constants/constants";
import Select from "../Select/Select";

const userTypesArr = Object.values(USER_TYPES_WITH_ADMIN);

const propTypes = {
  selectedUserType: PropTypes.object,
  onSelectSeller: PropTypes.func,
  onSelectUserType: PropTypes.func,
  sellersOptions: PropTypes.array,
  userTypesOptions: PropTypes.array,
  selectedSeller: PropTypes.object,
  disabled: PropTypes.bool,
};

export default function UserTypesDropdown(props) {
  const {
    selectedUserType,
    onSelectSeller,
    onSelectUserType,
    sellersOptions,
    selectedSeller,
    userTypesOptions,
    disabled,
  } = props;

  return (
    <Select
      options={sellersOptions}
      value={selectedSeller}
      isClearable
      onChange={onSelectSeller}
      isDisabled={disabled}
      className="report-dropdown"
    />
  );
}

UserTypesDropdown.propTypes = propTypes;
